module.exports = __webpack_public_path__ + "media/images/gallery/constellations/leo_minor/lmi_lines-6723d08b113e7d92e98840bb95879779.gif";